import { render, staticRenderFns } from "./success.vue?vue&type=template&id=352c8a6b&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=352c8a6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c8a6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352c8a6b')) {
      api.createRecord('352c8a6b', component.options)
    } else {
      api.reload('352c8a6b', component.options)
    }
    module.hot.accept("./success.vue?vue&type=template&id=352c8a6b&scoped=true&", function () {
      api.rerender('352c8a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/success.vue"
export default component.exports